'use client';

import get from 'lodash/get';
import { COLORS } from '@/common/constants';
import { useTranslations } from 'next-intl';
import { twMerge } from 'tailwind-merge';

// Icon components (ví dụ dùng SVG inline hoặc import từ thư viện icon)
const LocationIcon = () => (
  <svg className="w-5 h-5 mr-2 inline-block text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
    />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);
const PhoneIcon = () => (
  <svg className="w-5 h-5 mr-2 inline-block text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      // eslint-disable-next-line max-len
      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
    />
  </svg>
);
const EmailIcon = () => (
  <svg className="w-5 h-5 mr-2 inline-block text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
    />
  </svg>
);

export default function Contact({ contacts }) {
  const contactInfo = get(contacts, 'results[0]');

  const t = useTranslations('');

  return (
    <>
      {/* Tiêu đề trang */}
      <h1 className={twMerge('text-2xl font-bold mb-6 uppercase pb-2', COLORS.primary)}>{t('contact.contact')}</h1>

      {/* ----- Thông tin liên hệ ----- */}
      {contactInfo && (
        <div className="space-y-5 text-gray-700 leading-relaxed">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">{contactInfo?.name}</h2>
          <p>
            <LocationIcon />
            <strong>{t('contact.address')}:</strong> {contactInfo?.position}
          </p>
          <p>
            <PhoneIcon />
            <strong>{t('contact.phone')}:</strong> {contactInfo?.phone}
          </p>
          <p>
            <EmailIcon />
            <strong>Email:</strong>
            <a href={`mailto:${contactInfo?.email}`} className="text-blue-600 hover:underline">
              {contactInfo?.email}
            </a>
          </p>
          {contactInfo?.url && (
            <p>
              {/* Thay icon nếu muốn */}
              <svg
                className="w-5 h-5 mr-2 inline-block text-red-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m-9 9a9 9 0 019-9"
                />
              </svg>
              <strong>Website:</strong>
              <a href={`http://${contactInfo?.url}`} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                {contactInfo?.url}
              </a>
            </p>
          )}

          {/* Giờ làm việc (Ví dụ) */}
          <div className="pt-3">
            <h3 className="font-semibold text-gray-800 mb-1">{t('contact.workingHours')}:</h3>
            {contactInfo?.note}
          </div>
        </div>
      )}
    </>
  );
}
